import {managersService} from 'services';

const managersStore = {
  namespaced: true,
  state () {
    return {
      managersList: []
    };
  },
  getters: {
    managersList: state => state.managersList
  },
  mutations: {
    SET_MANAGERS_LIST (state, managersList) {
      state.managersList = managersList;
    }
  },
  actions: {
    async FETCH_MANAGERS_LIST (context) {
      const managers = await managersService.getManagersList();
      context.commit('SET_MANAGERS_LIST', managers.items);
    }
  }
};

export default managersStore;
